export default {
    data() {
        return {
            email: '',
            emailError: false,
            submitted: false
        };
    },
    methods: {
        submit() {
            this.emailError = false;
            const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (this.email.match(validEmailRegex)) {
                this.$axios
                    .post('https://api.broker.compary.com/users', {
                        email: this.email,
                        guide_id: process.env.BROKER_GUIDE_ID,
                        tracking: this.$tracking.getTrackingObject(),
                        redirect_url: null
                    })
                    .then(() => {
                        this.submitted = true;
                    });
            }
            else {
                this.emailError = true;
            }
        }
    }
};